import gsap from 'gsap';
gsap.config({ nullTargetWarn: false });

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

// Lib
import "./lib/jquery";
import "./lib/jquery-ui";
import "@fancyapps/fancybox";
import "./lib/nice-select";
import "./lib/pixi";

// Layout
import './layout/sidebar'
import './layout/header'
import './layout/footer'

// Page
import './page/homepage'
import './page/contracted-corporations'
import './page/services'
import './page/service-detail'
import './page/doctor-list'
import './page/doctor-detail'
import './page/blog-list'
import './page/blog-detail'
import './page/about-us'
import './page/help'
import './page/contact'
import './page/error'
import './page/contract'
import './page/appointment'
import './page/departments'
import './page/hospital-list'
import './page/hospital-detail'
import './page/human-resources'

// Load
import './load'

// Model
import './model'
import './model-plane'

$(function () {
    // Default Ease
    let defaultEase = "circ.inOut";

    setTimeout(() => {
        gsap.to(window, { duration: 0.1, ease: "none", scrollTo: 0 })
        window.scrollTo(0, 0)
    }, 100);

    // Message Item
    $(".message-item .item-close").click(function () {
        $(this).parent().fadeOut()
    });

    // Pre Loader
    setTimeout(() => {
        gsap.to(".pre-loader .loader-container", {
            x: 0,
            delay: 0.1,
            duration: 0.5,
            ease: "circ.inOut",
        })

        const preLoaderTL = gsap.timeline()
        preLoaderTL.to(".pre-loader .item", {
            x: 0,
            stagger: 0.1,
            duration: 0.5,
            ease: "circ.inOut",
        })
        preLoaderTL.to(".pre-loader .item > svg", {
            x: 0,
            stagger: 0.1,
            duration: 0.5,
            ease: "circ.inOut",
        })
        preLoaderTL.to(".pre-loader .item-reverse", {
            x: "100%",
            delay: 1,
            stagger: 0.1,
            duration: 0.5,
            ease: "circ.inOut",
        })
        preLoaderTL.to(".pre-loader .item-reverse > svg", {
            x: "-110%",
            stagger: 0.1,
            duration: 0.5,
            ease: "circ.inOut",
        }, "-=1")
        preLoaderTL.to(".pre-loader .item-3", {
            x: "-50%",
            duration: 0.5,
            ease: "circ.inOut",
        }, "-=1")
        preLoaderTL.to(".pre-loader .item-3 > svg:nth-child(1)", {
            opacity: 0,
            duration: 0.5,
            ease: "circ.inOut",
        }, "-=1")
        preLoaderTL.to(".pre-loader .item-3-circle", {
            opacity: 1,
            duration: 0.5,
            ease: "circ.inOut",
        }, "-=1")

        setTimeout(() => {
            const loaderCircle = gsap.timeline({ repeat: -1 })
            loaderCircle.to(".pre-loader .item-3-circle svg:nth-child(1)", {
                rotate: 360,
                duration: 1.5,
                ease: "circ.inOut",
            })
        }, 1000);
    }, 100);

    // Circle Text
    function circularText(txt, radius, classIndex) {
        txt = txt.split(""),
            classIndex = document.getElementsByClassName("circle-text")[classIndex];

        var deg = 360 / txt.length,
            origin = 0;

        txt.forEach((ea) => {
            ea = `<p 
                    style='height:${radius}px; position:absolute; transform:rotate(${origin}deg); transform-origin:0 100%'
                >
                    ${ea}
                </p>`;
            classIndex.innerHTML += ea;
            origin += deg;
        });
    }

    $(".circle-text").each(function (index) {
        let text = $(this).attr("data-circle-text")
        let size = $(this).attr("data-circle-size")

        $(this).css({
            width: (size * 2) + "px",
            height: (size * 2) + "px",
        })

        circularText(text, size, index);
    });

    // Fancybox
    $('data-fancybox').fancybox();

    // Nice Select
    $(".nice-select").niceSelect();

    // Footer
    if (!$(".about-section").length) {
        function footerAni() {
            gsap.to(".footer-top", {
                y: 0,
                ease: "none",

                scrollTrigger: {
                    trigger: ".footer-trigger",
                    start: "top bottom-=100",
                    end: "top-=300 top",
                    scrub: true,
                }
            })
        }

        if ($(window).width() >= 1200) {
            footerAni()
        }

        $(window).resize(function () {
            if ($(window).width() >= 1200) {
                footerAni()
            }
        });
    }

    // PIXI
    // Set up the variables needed and loads the images to create the effect.
    // Once the images are loaded the ‘setup’ function will be called.
    new PIXI.utils.skipHello();

    if (window.innerWidth >= 1200) {
        if (document.querySelectorAll(".ani-banner-item").length > 0) {
            document.querySelectorAll(".ani-banner-item").forEach(function (item) {
                var app = new PIXI.Application(item.clientWidth, item.clientHeight);
                item.appendChild(app.view);

                app.stage.interactive = true;
                var posX, displacementSprite, displacementFilter, bg, vx;
                var container = new PIXI.Container();
                app.stage.addChild(container);

                PIXI.loader.add("./assets/img/ripple.png").add(item.dataset.img).load(setup);

                // In the ‘setup’ function the displacement sprite is created
                // that will create the effect and this is added to a displacement filter.
                // It’s then set to move its anchor point to the centre of the image and positioned on the screen.
                function setup() {
                    posX = app.renderer.width / 2;
                    displacementSprite = new PIXI.Sprite(PIXI.loader.resources["./assets/img/ripple.png"].texture);
                    displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite);
                    displacementSprite.anchor.set(0.5);
                    displacementSprite.x = app.renderer.width / 2;
                    displacementSprite.y = app.renderer.height / 2;
                    vx = displacementSprite.x;

                    // To finish off the ‘setup’ function, the displacement filter scale is set and the background positioned.
                    // Notice the scale is ‘0’ for the displacement, that’s because it will be set to a height as soon as the mouse moves.

                    app.stage.addChild(displacementSprite);
                    container.filters = [displacementFilter];
                    displacementFilter.scale.x = 0;
                    displacementFilter.scale.y = 0;
                    bg = new PIXI.Sprite(PIXI.loader.resources[item.dataset.img].texture);
                    bg.width = app.renderer.width;
                    bg.height = app.renderer.height;
                    container.addChild(bg);

                    // app.stage.on('mousemove', onPointerMove).on('touchmove', onPointerMove);
                    item.addEventListener('mousemove', function (e) {
                        onPointerMove(e.clientX - item.getBoundingClientRect().left)
                    });

                    loop();
                }

                // grab the position of the mouse on the x-axis whenever the mouse moves.

                function onPointerMove(eventData) {
                    posX = eventData;
                }

                // create a function that continually updates the screen. A velocity for the x-axis is worked out using the position of the mouse and the ripple.

                function loop() {
                    requestAnimationFrame(loop);
                    vx += (posX - displacementSprite.x) * 0.06;
                    displacementSprite.x = vx;
                    var disp = Math.floor(posX - displacementSprite.x);
                    if (disp < 0) disp = -disp;
                    var fs = map(disp, 0, 500, 0, 120);
                    disp = map(disp, 0, 500, 0.1, 0.6);
                    displacementSprite.scale.x = disp;
                    displacementFilter.scale.x = fs;
                }
            });

            // Finally, the map function is declared that maps value ranges to new values.
            const map = function (n, start1, stop1, start2, stop2) {
                var newval = (n - start1) / (stop1 - start1) * (stop2 - start2) + start2;
                return newval;
            }
        };
    } else {
        if ($(".ani-banner-item").length > 0) {
            $(".ani-banner-item").each(function (item) {
                $(this).append('<div class="img" style="background-image: url(' + $(this).data("img") + ');"></div>')
            });
        };
    }

    // Animation
    setTimeout(() => {
        function loadAnimation() {
            // Social Media
            gsap.to(".main-content .social-media > span", {
                x: 0,
                autoAlpha: 1,
                delay: 0.1,
                stagger: 0.1,
                duration: 0.8,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".main-content .social-media",
                    start: "top bottom-=100"
                }
            })

            gsap.to(".main-content .social-media li", {
                y: 0,
                autoAlpha: 1,
                stagger: 0.1,
                duration: 0.8,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".main-content .social-media",
                    start: "top bottom-=100"
                }
            })

            // Banner Item
            if (!$(".service-detail").length) {
                gsap.to(".banner-item", {
                    y: 0,
                    autoAlpha: 1,
                    duration: 0.8,
                    ease: defaultEase,
                })
            }

            if (!$(".services").length) {
                gsap.to(".banner-item .img-container .img", {
                    y: -100,
                    scale: 1.5,
                    ease: "none",

                    scrollTrigger: {
                        trigger: ".banner-item",
                        start: "top top+=200",
                        end: "bottom top",
                        scrub: true,
                    }
                })
            }

            // List Header
            gsap.to(".list-header .header-title", {
                autoAlpha: 1,
                y: 0,
                delay: 0.1,
                duration: 0.8,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".list-header",
                    start: "top bottom-=100",
                }
            })

            gsap.to(".list-header .header-title span", {
                scale: 1,
                delay: 0.2,
                duration: 0.8,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".list-header",
                    start: "top bottom-=100",
                }
            })

            gsap.to(".list-header .select-item", {
                y: 0,
                autoAlpha: 1,
                delay: 0.1,
                stagger: 0.1,
                duration: 0.8,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".list-header",
                    start: "top bottom-=100",
                }
            })
        }

        if ($(window).width() >= 1200) {
            loadAnimation();
        }

        $(window).resize(function () {
            if ($(window).width() >= 1200) {
                loadAnimation();
            }
        });

        // Tab Menu Ani
        if ($(".tab-menu").length) {
            gsap.to(".tab-menu ul li", {
                x: 0,
                autoAlpha: 1,
                stagger: 0.1,
                duration: 0.8,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".tab-menu",
                    start: "top bottom-=100",
                }
            })

            gsap.to(".tab-menu .tab-menu-line", {
                width: "100%",
                duration: 0.8,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".tab-menu",
                    start: "top bottom-=100",
                }
            })

            // Tab Content
            let clickCheck = false;

            let firstWidth = $(".tab-menu ul li:nth-child(2) a").width()
            gsap.to(".tab-menu-content-line", {
                width: firstWidth + 20,
                delay: 0.2,
                duration: 0.8,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".tab-menu",
                    start: "top bottom-=100",
                }
            })

            gsap.to(".tab-content > .content-item:nth-child(1)", {
                autoAlpha: 1,
                y: 0,
                height: "auto",
                overflow: "initial",
                duration: 0.1,
            })

            setTimeout(() => {
                $(".tab-content").css("height", $(".tab-content > .content-item:nth-child(1)").innerHeight() + "px")
                $(".tab-content").attr("data-height", $(".tab-content > .content-item:nth-child(1)").innerHeight())
                $(".tab-content > .content-item:nth-child(1)").css("height", "100%")
            }, 500);

            $(".about-section .help-content .content-item").click(function () {
                setTimeout(() => {
                    gsap.to(".about-tab-content", {
                        height: $(".about-tab-content").data("height") + $(this).parent().innerHeight() - (window.innerWidth <= 767 ? 300 : 400),
                        duration: 0.2,
                    })
                }, 600);
            });

            $(".tab-menu ul li a").click(function () {
                let menuIndex = $(this).parent().index() - 1
                clickCheck = true;

                //--

                setTimeout(() => {
                    if ($(window).width() >= 1200) {
                        footerAni()
                    }

                    $(window).resize(function () {
                        if ($(window).width() >= 1200) {
                            footerAni()
                        }
                    });
                }, 100);

                //--

                let itemPosition = $(this).parent().position().left;
                let itemOffset = $(this).parent().offset().left;
                let marginLeft = parseInt($(this).parent().css("margin-left"));
                let calcX;

                let overflowXCheck = $(this).parent().parent().css("overflow-x");

                if (overflowXCheck == "auto") {
                    let totalWidth = 0;

                    $(".tab-menu ul li").each(function (index) {
                        if ((index + 1) < menuIndex + 1) {
                            totalWidth += parseInt($(this).width() + parseInt($(this).css("margin-left")));
                        }
                    });

                    calcX = totalWidth + 40;
                } else {
                    calcX = parseInt((itemOffset - marginLeft) - 60);
                }

                if (menuIndex == 0) {
                    calcX = 0;
                }

                gsap.to(".tab-menu-content-line", {
                    width: $(this).width() + 20,
                    x: calcX,
                    duration: 0.8,
                    ease: defaultEase,
                })

                //--

                $(".help-section .help-content .content-item").click(function () {
                    setTimeout(() => {
                        gsap.to($(".dr-detail-tab-content"), {
                            height: $(this).parent().innerHeight(),
                            duration: 0.2,
                        })
                    }, 500);
                });

                //--

                $(this).addClass("active").parent().siblings().children().removeClass("active");

                gsap.to(window, { duration: 0.8, ease: defaultEase, scrollTo: ($(this).parents(".tab-menu").offset().top - 100) })

                $(".tab-content > .content-item").each(function () {
                    if (menuIndex == $(this).index()) {
                        $(this).addClass("active");

                        gsap.to($(this), {
                            autoAlpha: 1,
                            y: 0,
                            duration: 0.5,
                            ease: defaultEase
                        })

                        gsap.to($(this), {
                            height: "auto",
                            overflow: "initial",
                            duration: 0.1,
                        })

                        setTimeout(() => {
                            $(this).parent().attr("data-height", $(this).innerHeight())
                            gsap.to($(this).parent(), {
                                height: $(this).innerHeight(),
                                duration: 0.2,
                            })

                            setTimeout(() => {
                                gsap.to($(this), {
                                    height: "100%",
                                    duration: 0.1,
                                })
                            }, 300);
                        }, 300);
                    } else {
                        $(this).removeClass("active");

                        gsap.to($(this), {
                            autoAlpha: 0,
                            y: 64,
                            height: 0,
                            overflow: "hidden",
                            duration: 0.1,
                        })
                    }
                });
            });
        }
    }, 800);
})